import { Dayjs } from 'dayjs';
import React from 'react';
import { Delay } from '../../models';

import './TimeRange.css';

type TimeRangeProps = {
  startTime: Dayjs;
  endTime: Dayjs;
  funnelStart: Dayjs;
  funnelEnd: Dayjs;
  delay?: Delay;
};

export const TimeRange: React.FC<TimeRangeProps> = ({
  startTime,
  endTime,
  funnelEnd,
  funnelStart,
  delay,
}) => {
  const minutePercentageWidth = 100 / endTime.diff(startTime, 'minutes');
  const left = minutePercentageWidth * funnelStart.diff(startTime, 'minutes');
  const width = minutePercentageWidth * funnelEnd.diff(funnelStart, 'minutes');

  let delayClass: string = '';

  if (delay === Delay.Slight) {
    delayClass = 'time-range--warning-color';
  } else if (delay === Delay.Major) {
    delayClass = 'time-range--danger-color';
  }

  return (
    <div>
      <div className="time-range--default-line">
        <div
          style={{ width: `${width}%`, left: `${left}%` }}
          className={`time-range--funnel-line ${delayClass}`}
        />
      </div>
      <div className="time-range--times-container">
        <p className="time-range--time">{startTime.format('HH:mm')}</p>
        <p className="time-range--time time-range--end-time">
          {endTime.format('HH:mm')}
        </p>
      </div>
    </div>
  );
};
